interface DjKeypadProps {
  value: string;
  onChange: (value: string) => void;
  onPlay: () => void;
  disabled?: boolean;
}

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'back', '0', 'play'] as const;

/** Крупная цифровая клавиатура пульта. */
export const DjKeypad = ({ value, onChange, onPlay, disabled }: DjKeypadProps) => {
  const handleKey = (key: (typeof KEYS)[number]) => {
    if (disabled) return;
    if (key === 'back') {
      onChange(value.slice(0, -1));
      return;
    }
    if (key === 'play') {
      onPlay();
      return;
    }
    if (value.length >= 3) return;
    onChange(value + key);
  };

  return (
    <div className="dj-keypad">
      <div className="dj-keypad-display">{value || '—'}</div>
      <div className="dj-keypad-grid">
        {KEYS.map((key) => (
          <button
            key={key}
            type="button"
            className={`dj-keypad-key ${key === 'play' ? 'dj-keypad-play' : ''} ${key === 'back' ? 'dj-keypad-back' : ''}`}
            disabled={disabled}
            onClick={() => handleKey(key)}
          >
            {key === 'back' ? '⌫' : key === 'play' ? 'Играть' : key}
          </button>
        ))}
      </div>
    </div>
  );
};
